/** 構造形式混合構造 */
export const CONSTRUCTION_METHOD_MIXED = {
  UNSELECTED: '-1',
  REINFORCED: '21',
  PRECAST: '22',
  BLOCK: '23',
  STEEL_REINFORCED: '24'
} as const
